module.exports = __webpack_public_path__ + "img/header_image.e81a50a3.png";